import Image from "next/image";

import CheckMarks from "@/components/common/CheckMarks";
import { points } from "@/constants/UIUXData";
import { twMerge } from "tailwind-merge";
import { useIsDark } from "@/context/ThemeContext";

export default function LastSection() {
  const isdark = useIsDark();
  return (
    <div className="flex flex-col sm:flex-row justify-between items-between w-full max-w-[2000px] laptop:h-[420px] mt-25 gap-5 sm:gap-2">
      <section className="flex flex-col items-center sm:items-start justify-between xl:w-[525px] 2xl:w-[650px]">
        <h1 className="font-alexandria font-semibold text-[22px] sm:text-[26px] xl:text-[38px] laptop:text-[52px] 3xl:text-[58px] uppercase leading-tight text-center sm:text-left">
          why brands love working with us
        </h1>

        {/* card */}
        <div className="hidden mobile:block">
          <div
            className={twMerge(
              "w-[320px] h-[108px] xl:w-[492px] xl:h-[162px] rounded-2xl dark:p-[2px] p-px",
              isdark
                ? "bg-gradient-to-r from-[#161616] to-[#FFFFFF26]"
                : "bg-gradient-to-b from-[#FF1CF7] to-[#FFFFFF26]"
            )}
          >
            <div className="w-full h-full rounded-2xl bg-section">
              <div className="flex items-center justify-between font-inter font-normal">
                {/* top part */}
                <div
                  className={twMerge(
                    "w-[212px] h-[35px] xl:w-[309px] xl:h-[52px] p-px rounded-full ml-[5px] mt-1",
                    isdark
                      ? "bg-gradient-to-br from-[#161616] to-[#FFFFFF26]"
                      : "bg-gradient-to-b from-[#FF1CF7] to-[#FFFFFF26]"
                  )}
                >
                  <div className="w-full h-full rounded-full bg-section">
                    <div className="flex gap-2 pt-3">
                      <div className="w-[26px] h-[26px] p-px rounded-full bg-gradient-to-tr from-[#DF27DF] to-[#FFFFFF] ml-2">
                        <img
                          src="/assets/profile.png"
                          className="w-full h-full rounded-full object-cover"
                          alt="Profile"
                        />
                      </div>
                      <div>
                        <p className="text-[8px] xl:text-[13px]">
                          <span className="text-[#1A1A1A] dark:text-[#FFFFFFEF]">
                            James Reynolds
                          </span>
                          <span className="text-[9px] xl:text-sm text-[#000000B5] dark:text-[#818589] pl-3">
                            sarah@resend.com
                          </span>
                        </p>
                        <p className="text-[6px] xl:text-[10px] text-[#00000080] dark:text-[#818589]">
                          CEO of RetailTech Solutions
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <p className="text-[8px] xl:text-[12px] text-[#00000080] dark:text-[#818589] mr-[15px]">
                  Jan 2nd, 2023
                </p>
              </div>

              {/* middle line */}
              <div
                className={twMerge(
                  "h-px w-full mt-[15px]",
                  isdark ? "bg-[#161616]" : "bg-[#0000000D]"
                )}
              />
              <div
                className=
                  "font-alexandria font-normal"
              >
                <p className={twMerge("pl-[15px] xl:pt-3 text-[16px] xl:text-[25px] text-transparent bg-clip-text bg-gradient-to-r from-[#9C00BB]",
                  isdark ? "to-[#FFFFFF]" : "to-[#1A1A1A]")}>
                  RetailTech Solutions
                </p>
                <p className={twMerge("pl-[160px] xl:pl-[325px] text-[12px] xl:text-[15px] text-transparent bg-clip-text bg-gradient-to-r from-[#9C00BB]",
                  isdark ? "to-[#FFFFFF]" : "to-[#1A1A1A]")}>
                  -LogisticsPro UI/UX
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="">
        <CheckMarks points={points} />
      </section>
    </div>
  );
}
